'use client'
import * as React from 'react'
import { LazyMotion, m, domAnimation, AnimatePresence } from 'framer-motion'
import { useDomEvent } from 'hooks/use-dom-event'

import { FeatureButton } from './feature-button'

const STICKY_HEIGHT = '84px'

export function FeatureStickyButton({
  label,
  href,
  hideCtaIcon = false,
}: {
  label: string
  href: string
  hideCtaIcon?: boolean
}) {
  const [showStickyButton, setShowStickyButton] = React.useState(false)
  const showStickyButtonRef = React.useRef<HTMLDivElement>(null)

  function handleScroll() {
    const element = showStickyButtonRef.current

    if (element) {
      const elementDistance = element.getBoundingClientRect().top

      if (window.scrollY >= elementDistance) {
        setShowStickyButton(true)
        document.body.style.paddingBottom = STICKY_HEIGHT
      } else {
        setShowStickyButton(false)
      }
    }
  }

  useDomEvent(useDomEvent.window, 'scroll', React.useCallback(handleScroll, []))

  return (
    <>
      <div ref={showStickyButtonRef} />
      <LazyMotion features={domAnimation}>
        <AnimatePresence>
          {showStickyButton ? (
            <m.div
              animate={{ y: '0%' }}
              initial={{ y: '100%' }}
              exit={{ y: '100%' }}
              transition={{ duration: 0.3, ease: 'easeInOut' }}
              style={{ height: STICKY_HEIGHT }}
              className="fixed-banner text-service-white bg-service-white scroll-adjust-padding-[10px] fixed bottom-0 z-[10] flex w-full items-center justify-center py-5 pl-[10px] shadow-[0_-3px_8px_rgba(64,87,109,.07)]"
            >
              <FeatureButton label={label} href={href} hideIcon={hideCtaIcon} />
            </m.div>
          ) : null}
        </AnimatePresence>
      </LazyMotion>
    </>
  )
}
